module.exports = __webpack_public_path__ + "img/img19.4922c62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/img19.jpg
// module id = 393
// module chunks = 0